import { css } from 'styled-components';
import { CURRENCY_MAP } from '../../../utils/currencies';
import type { ITheme } from '../../../utils/theme';

export const getCurrencyBorder = (
  hasError: boolean,
  isFocused: boolean,
  isDisabled: boolean,
  theme: ITheme
) => {
  if (hasError) {
    return `0.5px solid ${theme.palette.error.main}`;
  }
  if (isFocused) {
    return `0.5px solid ${theme.palette.neutral[100]}`;
  }
  if (isDisabled) {
    return `0.5px solid ${theme.palette.neutral[70]}`;
  }
  return `0.5px solid ${theme.palette.neutral[90]}`;
};

export const getCurrencyColor = (
  hasError: boolean,
  disabled: boolean,
  theme: ITheme
) => {
  if (hasError) {
    return theme.palette.error.main;
  }
  if (disabled) {
    return theme.palette.neutral['70'];
  }
  return theme.palette.neutral['100'];
};

export const getCurrencySelectBorder = (hasError: boolean, theme: ITheme) => {
  if (hasError) {
    return css`
      border: 0.5px solid ${theme.palette.error.main};
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    `;
  }

  return css`
    border: 0.5px solid ${theme.palette.neutral['80']};
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  `;
};

export const getPaddingLeft = (
  currency?: string,
  showCurrencySelect?: boolean
) => {
  const symbol =
    (currency && CURRENCY_MAP[currency as keyof typeof CURRENCY_MAP]) ?? '';
  const symbolWidth = symbol?.length * 8; // Rough width based on character count
  if (showCurrencySelect) {
    return `${100 + symbolWidth}px`;
  }
  return `${72 + symbolWidth}px`;
};
